exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CompanyCard-billingType-3rvHW{position:absolute;width:36px;height:36px;top:0;right:0;padding:5px}.CompanyCard-billingType-3rvHW div{width:26px;height:26px;line-height:29px;text-align:center;border-radius:100%;color:#fff;font-weight:700}.CompanyCard-billingType-3rvHW .CompanyCard-StandardAccount-2q-AL{background-color:#b0252e}.CompanyCard-billingType-3rvHW .CompanyCard-PremiumAccount-3cSy1{background-color:#00e5ce}.CompanyCard-label-DNLXx{padding:10px 0}.CompanyCard-label-DNLXx h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.CompanyCard-status-2l96z{float:right}", ""]);

// exports
exports.locals = {
	"billingType": "CompanyCard-billingType-3rvHW",
	"StandardAccount": "CompanyCard-StandardAccount-2q-AL",
	"PremiumAccount": "CompanyCard-PremiumAccount-3cSy1",
	"label": "CompanyCard-label-DNLXx",
	"status": "CompanyCard-status-2l96z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/company/components/CompanyCard.less
// module id = 1616
// module chunks = 0